import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class DeleteSchedulesRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('deleteSchedules', { ids: ids });
  }
}
